import React from "react";
import { withTheme } from "styled-components";
import Flex from "@irati/ui/src/Flex";
import { Body, Label, H5 } from "@irati/ui/src/Typography";
var CardBody = function (_a) {
    var brandName = _a.brandName, title = _a.title, desc = _a.desc, theme = _a.theme;
    return (React.createElement(Flex, { direction: "column" },
        React.createElement(Flex, { margin: "0px 0px " + theme.spacing.oneAndHalf + " 0px" },
            React.createElement(Label, { large: true }, brandName)),
        React.createElement(Flex, { margin: "0px 0px " + theme.spacing.two + " 0px", height: "48px" },
            React.createElement(H5, { overflowWrap: "break-word" }, title)),
        React.createElement(Flex, null,
            React.createElement(Body, { small: true, overflowWrap: "break-word" }, desc))));
};
export default withTheme(CardBody);
